export const BILL_PAY = 'billpay'
